import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EngineService } from '../_services/engine.service';
import { AuthService } from '../_services/auth.service';

@Injectable()
export class LightShowGuard implements CanActivate {
  constructor(private engineService: EngineService, private authService: AuthService,  private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.engineService.hasServiceType('lightshow').pipe(map(
        result => {
            if (result) {
                return true;
            }
            console.log('You are not authorized to access this area');
            this.authService.logout().subscribe(() => this.router.navigate(['/login']));
            return false;
        }));
    }
}

@Injectable()
export class SelfieCamGuard implements CanActivate {
  constructor(private engineService: EngineService, private authService: AuthService,  private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.engineService.hasServiceType('selfiecam').pipe(map(
        result => {
            if (result) {
                return true;
            }
            console.log('You are not authorized to access this area');
            this.authService.logout().subscribe(() => this.router.navigate(['/login']));
            return false;
        }));
    }
}

@Injectable()
export class TriviaGuard implements CanActivate {
  constructor(private engineService: EngineService, private authService: AuthService,  private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.engineService.hasServiceType('triviagame').pipe(map(
        result => {
            if (result) {
                return true;
            }
            console.log('You are not authorized to access this area');
            this.authService.logout().subscribe(() => this.router.navigate(['/login']));
            return false;
        }));
    }
}

@Injectable()
export class CoreEngineGuard implements CanActivate {
  constructor(private engineService: EngineService, private authService: AuthService,  private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.engineService.hasServiceType('genericengine').pipe(map(
        result => {
            if (result) {
                return true;
            }
            console.log('You are not authorized to access this area');
            this.authService.logout().subscribe(() => this.router.navigate(['/login']));
            return false;
        }));
    }
}

@Injectable()
export class UpnGuard implements CanActivate {
  constructor(private engineService: EngineService, private authService: AuthService,  private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.engineService.hasServiceType('upn').pipe(map(
        result => {
            if (result) {
                return true;
            }
            console.log('You are not authorized to access this area');
            this.authService.logout().subscribe(() => this.router.navigate(['/login']));
            return false;
        }));
    }
}

@Injectable()
export class CouponGuard implements CanActivate {
  constructor(private engineService: EngineService, private authService: AuthService,  private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.engineService.hasServiceType('coupons').pipe(map(
        result => {
            if (result) {
                return true;
            }
            console.log('You are not authorized to access this area');
            this.authService.logout().subscribe(() => this.router.navigate(['/login']));
            return false;
        }));
    }
}

@Injectable()
export class Cue5050Guard implements CanActivate {
  constructor(private engineService: EngineService, private authService: AuthService,  private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.engineService.hasServiceType('fundraising').pipe(map(
        result => {
            if (result) {
                return true;
            }
            console.log('You are not authorized to access this area');
            this.authService.logout().subscribe(() => this.router.navigate(['/login']));
            return false;
        }));
    }
}

@Injectable()
export class PledgePerWinGuard implements CanActivate {
  constructor(private engineService: EngineService, private authService: AuthService,  private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.checkFeatureFlag('PledgePerWin').pipe(map(
        result => {
            if (result) {
                return true;
            }
            console.log('You are not authorized to access this area');
            this.authService.logout().subscribe(() => this.router.navigate(['/login']));
            return false;
        }));
    }
}
